module.exports = __webpack_public_path__ + "img/danielaRizzi@2x.f67994c5.jpg";